<!-- 消息中心 -->
<template>
    <div class='container containerBox'>
        <!-- 头部筛选区 -->
        <div class="handle-box">
            <el-form :inline="true" :model="handleForm" class="demo-form-inline">
                <!-- <el-form-item label="消息类型">
                    <el-select v-model="handleForm.messageType" placeholder="请选择消息类型">
                        <el-option label="系统消息" value="0"></el-option>
                        <el-option label="设备消息" value="1"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="状态">
                    <el-select v-model="handleForm.solved" placeholder="请选择状态">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option label="未解决" :value="1"></el-option>
                        <el-option label="已解决" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否已读">
                    <el-select v-model="handleForm.read" placeholder="请选择状态">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option label="未读" :value="1"></el-option>
                        <el-option label="已读" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="消息日期">
                    <el-date-picker
                        v-model="handleForm.date"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item> -->
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="">
            <el-button size="small" type="primary" plain @click="handleAllRead('chose')" >标记为已读</el-button>
            <el-button size="small" type="primary" plain @click="handleAllRead('all')" >全部标记为已读</el-button>
            <el-button size="small" type="danger" plain @click="handleAllRead('del')" >删除选中</el-button>
            <!-- <el-button size="small" type="danger" @click="handleAllRead('alldel')" >清空消息</el-button> -->
        </div>
        <!--  -->
        <l-table
            :list="tableData"
            :total="total" 
            :otherHeight="284"
            :options="options"
            :pagination="pagination"
            :columns="columns" 
            :operates="operates"
            @handleSelectionChange="handleSelectionChange"
            @handleSizeChange="handleSizeChange"
            @handleIndexChange="handleIndexChange">
        </l-table>
    </div>
</template>

<script>
import Service from '@/api/Service'
import lTable from '@/components/lTable/lTable'

export default {
    name:  'messagecenter',
    inject: ["reload"],
    data() {
        return {
            handleForm: {
                top: 0,
                solved: 0,
                read: 0,
            },

            tableData: [],
            multipleSelection: [],

            // 表格栏
            total: 0,
            pagination: {
                page_num: 1,
                page_sum: 10
            },
            columns: [
                {
                    prop: 'read',
                    label: '',
                    width: "55",
                    align: 'center',
                    sortable: true,
                    render: (h, params) => {
                        var self = this;
                        if(params.row.read === 1) {
                            return h('el-badge', {
                                class: { "read-is-dot": true },
                                props: { 'is-dot': true }, // 组件的props
                            },[
                                h('i', {
                                    class: {"iconfont icon-message-unread" : true },
                                    on: {
                                        "click": () => {
                                            this.handleRead(params.row);
                                        }
                                    }
                                })
                            ])
                        }else{
                            return h('i', {
                                class: {"iconfont icon-yiduxinxi": true },  // 组件的props
                            })
                        }
                    },
                },
                {
                    prop: 'title',
                    label: '标题',
                    align: 'center',
                },
                {
                    prop: 'solved',
                    label: '故障状态',
                    align: 'center',
                    render: (h, params) => {
                        if(params.row.warning_type === 1) {
                            return h('el-tag', {
                                props: {type: params.row.solved === 1 ? 'danger' : 'success',"disable-transitions": true} // 组件的props
                            }, params.row.solved === 1 ? '未解决' : '已解决')
                            
                        }else{
                           return null
                        }
                    }
                },
                {
                    prop: 'description',
                    label: '说明',
                    align: 'center',
                },
                {
                    prop: 'create_date',
                    label: '创建时间',
                    align: 'center',
                    
                },
                {
                    prop: 'update_date',
                    label: '更新时间',
                    align: 'center',
                    sortable: true,
                },
            ], // 需要展示的列
            operates: {
                width: 180,
                fixed: 'right',
                list: [
                    {
                        label: '解决',
                        type: 'primary',
                        show: (index, row) => {
                            return row.warning_type === 1 && row.solved === 1
                        },
                        icon: 'el-icon-edit',
                        plain: true,
                        disabled: (index, row) => {
                            return false
                        },
                        method: (index, row) => {
                            this.handleEdit(row)
                        },
                    },
                ]
            }, // 操作按钮组
            options: {
                stripe: true, // 是否为斑马纹 table
                loading: false, // 是否添加表格loading加载动画
                highlightCurrentRow: true, // 是否支持当前行高亮显示
                mutiSelect: true // 是否支持列表项选中功能
            }, // table 的参数
        };
    },

    components: { lTable },

    created() {
        this.getNoticeListdata()
    },

    methods: {
        async getNoticeListdata() {
            let params = Object.assign({}, this.pagination, this.handleForm);
            let data = await Service.getNoticeList(params);
            if(data){
                let list = data.list == null ? [] : data.list;
                this.tableData = list;
                this.total = data.total;
            }
        },
        // 切换页码
        handleSizeChange (pagination) {
            this.pagination = pagination
            this.getNoticeListdata()
        },
        // 切换页码
        handleIndexChange (pagination) {
            this.pagination = pagination
            this.getNoticeListdata()
        },
        // 选中消息
        handleSelectionChange (val) {
            this.multipleSelection = val;
        },
        // 查询
        onSubmit() {
            this.getNoticeListdata()
        },
        // 编辑
        async handleEdit(row) {
            let oid = {
                oid: row.oid + ""
            }
            let data = await Service.solveNotice({oidlist: [oid]});
            if(data) {
                this.getNoticeListdata()
                this.$message({
                    type: "success",
                    message: "操作成功"
                })
            }
        },
        handleRead(row) {
            let oid = {
                oid: row.oid + ""
            }
            
            this.read([oid])
        },
        async read(oidlist) {
            let data = await Service.readNotice({oidlist: oidlist});
            if(data) {
                this.getNoticeListdata();
                if(oidlist.length>1) {
                    this.$message({
                        type: "success",
                        message: "操作成功"
                    })
                }
            }
        },
        async readAll() {
            let res = await Service.readallNotice();
            if(res) {
                this.getNoticeListdata();
                this.$message({
                    type: "success",
                    message: "操作成功"
                })
            }
        },
        async delNotice() {
            let oidlist = this.multipleSelection.map(v=>{ return { oid: v.oid+"" }});
            let res = await Service.delNotice({oidlist});
            if(res) {
                this.getNoticeListdata();
                this.$message({
                    type: "success",
                    message: "操作成功"
                })
            }
        },
        // 全部标记已读
        handleAllRead(val) {
            switch (val) {
                case 'chose':
                // 标记已选择
                    if(this.multipleSelection.length>0) {
                        let oids = this.multipleSelection.map(v=>{
                            return {oid: v.oid + ""}
                        })
                        this.read(oids)
                    }else{
                        this.$notify({
                            title: '警告',
                            message: '请勾选消息',
                            type: 'warning'
                        });
                    }
                    break;
                case 'all':
                    // 标记全部
                    this.readAll()
                    break;
                case 'del': 
                    // 删除选中
                    if(this.multipleSelection.length<=0) {
                        this.$notify({
                            title: '警告',
                            message: '请选择要删除的消息',
                            type: 'warning'
                        });
                        return
                    }
                    this.delNotice();
                    break;
                case 'delall': 
                    // 清空
                    
                    break;
                default:
                    break;
            }
        },
    }
}

</script>
<style lang='less' scoped>

</style>